<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Laporan Renstra SKPD</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="Printing" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Cetak Data">
                                            <i class="material-icons">print</i>
                                        </button>
                                    </span>

                                    <input class="form-control" type="text">

                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">

                            <div class="col-md-6">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                            <div class="col-md-6">
                                
                            </div>

                        </div>

                        
                        <hr>
                        <div class="table-responsive" id="printMe">

                
               
                        <div>
                            <table style="width: 100%">
                                <tr>
                                    <td style="width: 10%" class="text-right">
                                        <img src="images/logo konsel.png" alt="" width="50">
                                    </td>
                                    <td style="width: 80%" class="text-center h_kop_1">
                                        <b>
                                                {{unit_kerja_full}}<br>
                                                PERIODE {{renstraku.periode}}
                                        </b>
                                    </td >
                                    <td style="width: 10%"></td>
                                </tr>
                            </table>

                            <hr>
                        </div>
                        <br>
                        <div class="text-center">
                            <span class="h_kop_1">VISI PEMKAB. <span style="text-transform : uppercase"> KONAWE SELATAN</span> </span>
                        </div>
                        <br><br>
                        <div>
                            <span style="text-transform : uppercase">
                                {{rpjmd_visi.uraian}}
                            </span>
                            <br><br>
                            <span><b>PENJABARAN VISI</b></span>
                            <br><br>
                            <span>{{renstra_visi.uraian}}</span>
                        </div>
                        <br><br>
                        <div class="text-center">
                            <span class="h_kop_1">
                                <b>MISI PEMKAB. <span style="text-transform : uppercase"> KONAWE SELATAN</span> YANG SESUAI TUGAS DAN FUNGSI PERANGKAT DAERAH</b>
                            </span>
                        </div>

                        <br>
                            <!-- ===== TOTAL TABEL 55% UNTUK CETAK ===== -->
                            <table class="table-kiken" style="width: 100%">
                                <thead>
                                    <tr class="bgcol_kop_table kepala_table_f tabel_center">
                                        <th class="tabel_center text-center" rowspan="2" style="width:100%">
                                            MISI
                                        </th>
                                    </tr>
                                </thead>

                                <tbody>
                                    <tr class="h_cetak_2 tabel_top" v-for="data in list_rpjmd_misi" :key="data.renstra_misi_id">
                                        <td class="cetak_col_kop">{{data.misi_uraian}}</td>
                                    </tr>
                                </tbody>
                            </table>


                            <br><br>
                            <div class="text-center">
                                <span class="h_kop_1">
                                    <b>TUJUAN</b>
                                </span>
                            </div> <br>

                            <table class="table-kiken" style="width: 100%">
                                <thead>
                                    <tr class="bgcol_kop_table h_cetak_2 tabel_center">
                                        <th class="tabel_center text-center" style="width:2%">NO</th>
                                        <th class="tabel_center text-center" style="width:35%">TUJUAN</th>
                                        <th class="tabel_center text-center" style="width:30%">INDIKATOR</th>
                                        <th class="tabel_center text-center" style="width:10%">TARGET</th>
                                        <th class="tabel_center text-center" style="width:20%">SATUAN</th>
                                        
                                    </tr>
                                </thead>

                                <tbody>
                                    <template v-for="data1 in list_renstra_misi">
                                        <tr class="h_cetak_2 tabel_top" :key="data1.renstra_misi_id">
                                            <td class="cetak_col_kop" colspan="5">Misi : {{data1.uraian}}</td>
                                        </tr>
                                        <template v-for="data2 in data1.renstra_tujuan">
                                            <template v-for="data3 in data2.renstra_indikator_tujuan" >
                                                <tr class="h_cetak_2 tabel_top" :key="data3.renstra_indikator_tujuan">
                                                    <td class="text-center">{{data1.nomor_renstra_misi}}.{{data2.no_renstra_tujuan}}</td>
                                                    <td class="">{{data2.uraian}}</td>
                                                    <td class="">{{data3.uraian}}</td>
                                                    <td class="text-center">{{data3.kondisi_akhir}}</td>
                                                    <td class="text-center">{{data3.satuan}}</td>
                                                </tr>
                                            </template>
                                        </template>
                                    </template>

                                </tbody>
                            </table>


                            <br><br>
                            <div class="text-center">
                                <span class="h_kop_1">
                                    <b>SASARAN</b>
                                </span>
                            </div> <br>

                            <table class="table-kiken" style="width: 100%">
                                <thead>
                                    <tr class="bgcol_kop_table kepala_table_f tabel_center">
                                        <th class="tabel_center text-center" style="width:5%">NO</th>
                                        <th class="tabel_center text-center" style="width:95%">SASARAN</th>
                                       
                                    </tr>
                                </thead>

                                <tbody>
                                    <template v-for="data1 in list_renstra_sasaran">
                                        <tr class="h_cetak_2 tabel_top" :key="data1.renstra_tujuan_id">
                                            <td colspan="2" class="cetak_col_kop">Tujuan : {{data1.uraian}}</td>
                                        </tr>
                                        <template  v-for="data2 in data1.renstra_sasaran">
                                            <tr class="h_cetak_2 tabel_top" :key="data1.renstra_tujuan_id+data2.renstra_sasaran_id">
                                                <td class="text-center">{{data1.no_renstra_tujuan}}.{{data2.no_renstra_sasaran}}</td>
                                                <td class="">{{data2.uraian}}</td>
                                            </tr>
                                        </template>
                                    </template>

                                </tbody>
                            </table>


                            <br><br>
                            <div class="text-center">
                                <span class="h_kop_1">
                                    <b>INDIKATOR SASARAN</b>
                                </span>
                            </div> <br>

                            <table class="table-kiken" style="width: 100%">
                                <thead>
                                    <tr class="bgcol_kop_table kepala_table_f tabel_center">
                                        <th class="tabel_center text-center" style="width:5%">NO</th>
                                        <th class="tabel_center text-center" style="width:65%">INDIKATOR KINERJA</th>
                                        <th class="tabel_center text-center" style="width:20%">SATUAN</th>
                                        <th class="tabel_center text-center" style="width:10%">IKU</th>
                                       
                                    </tr>
                                </thead>

                                <tbody>
                                    <template v-for="data1 in list_renstra_indikator_sasaran">
                                        <tr class="h_cetak_2 tabel_top" :key="data1.renstra_sasaran_id">
                                            <td colspan="5" class="cetak_col_kop">Sasaran : {{data1.uraian}}</td>
                                        </tr>
                                        <template v-for="data2 in data1.renstra_indikator_sasaran">
                                            <tr class="h_cetak_2 tabel_top" :key="data2.renstra_indikator_sasaran_id">
                                                <td class="text-center">{{data1.no_renstra_sasaran}}.{{data2.no_indikator}}</td>
                                                <td class="">{{data2.uraian}}</td>
                                                <td class="text-center">{{data2.satuan}}</td>
                                                <td class="text-center">v</td>
                                            </tr>
                                        </template>
                                    </template>

                                </tbody>
                            </table>


                            <br><br>
                            <div class="text-center">
                                <span class="h_kop_1">
                                    <b>TARGET INDIKATOR SASARAN</b>
                                </span>
                            </div> <br>

                            <table class="table-kiken" style="width: 100%">
                                <thead>
                                    <tr class="bgcol_kop_table kepala_table_f tabel_center">
                                        <th class="tabel_center text-center" style="width:5%">NO</th>
                                        <th class="tabel_center text-center" style="width:35%">INDIKATOR KINERJA</th>
                                        <th class="tabel_center text-center" style="width:10%">THN AWAL <br>(2016)</th>
                                        <th class="tabel_center text-center" style="width:10%">2017</th>
                                        <th class="tabel_center text-center" style="width:10%">2018</th>

                                        <th class="tabel_center text-center" style="width:10%">2019</th>
                                        <th class="tabel_center text-center" style="width:10%">2020</th>
                                        <th class="tabel_center text-center" style="width:10%">2021</th>
                                       
                                    </tr>
                                </thead>

                                <tbody>
                                    <template v-for="data1 in list_renstra_indikator_sasaran">
                                        <tr class="h_cetak_2 tabel_top" :key="data1.renstra_sasaran_id">
                                            <td colspan="8" class="cetak_col_kop">Sasaran 1 : {{data1.uraian}}</td>
                                        </tr>
                                        <template  v-for="data2 in data1.renstra_indikator_sasaran">
                                            <tr class="h_cetak_2 tabel_top" :key="data2.renstra_indikator_sasaran_id">
                                                <td class="text-center">{{data1.no_renstra_sasaran}}.{{data2.no_indikator}}</td>
                                                <td class="">{{data2.uraian}}</td>
                                                <td class="text-center">{{data2.thn_1}} {{data2.satuan}}</td>
                                                <td class="text-center">{{data2.thn_2}} {{data2.satuan}}</td>
                                                <td class="text-center">{{data2.thn_3}} {{data2.satuan}}</td>
                                                <td class="text-center">{{data2.thn_4}} {{data2.satuan}}</td>
                                                <td class="text-center">{{data2.thn_5}} {{data2.satuan}}</td>
                                                <td class="text-center">{{data2.thn_6}} {{data2.satuan}}</td>
                                            </tr>
                                        </template>
                                    </template>

                                </tbody>
                            </table>






                        </div>

                        
          
                        <!-- <hr> -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>


<script>


    const ADD_URL = URL_APP+'api/v1/planning_renstra_renstra/';
    const ADD_URL_RPJMD = URL_APP+'api/v1/planning_rpjmd/';
    const ADD_URL_UNIT_KERJA = URL_APP+'api/v1/simpeg_unit_kerja/';
    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'


    const ADD_KABUPATEN = URL_APP+'api/v1/planning_kabupaten/';
    const ADD_RENSTRA = URL_APP+'api/v1/planning_renstra_renstra/';
    const ADD_VISI = URL_APP+'api/v1/planning_visi/';
    const ADD_RENSTRA_VISI = URL_APP+'api/v1/planning_renstra_visi/';
    const ADD_RENSTRA_MISI = URL_APP+'api/v1/planning_renstra_misi/';
    const ADD_RENSTRA_SASARAN = URL_APP+'api/v1/planning_renstra_sasaran/';
    


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
                
                renstraku : '',
                rpjmd_id : '',

                unit_kerja : '',
                unit_kerja_full : '',

                rpjmd_visi : {},
                renstra_visi : '',

                list_rpjmd_misi : [],
                list_renstra_misi : [],
                list_renstra_sasaran : [],
                list_renstra_indikator_sasaran : [],


                periode : '', 
                tahun_awal : '', 
                tahun_akhir : '', 
                rpjmd_id : '', 
                no_perda : '', 
                tgl_perda : '', 
                keterangan : '', 
                status : '', 


                list_RPJMD: [],
                list_data : [],
                list_unit_kerja : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                nama_kabupaten : '',

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;


            this.getData();

            
            // localStorage.sidemenu = 'planing';
        },

    // =============================================================== METHODS =========================================================================
        methods : {
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      unit_kerja : this.unit_kerja,
                      rpjmd_id : this.rpjmd_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                //   console.log(res_data);
                })
            },


        //TAMBAHAN
            getRPJMD : function(){
                this.page_first = 1;
                fetch(ADD_URL_RPJMD, {
                    method : 'GET',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    }
                }).then(res => res.json()).then((res_data)=>{
                    this.list_RPJMD = res_data;
                    // console.log(res_data);
                })
            },
            getUnitKerja : function(){
                this.page_first = 1;
                fetch(ADD_URL_UNIT_KERJA, {
                    method : 'GET',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    }
                }).then(res => res.json()).then((res_data)=>{
                    this.list_unit_kerja = res_data;
                    // console.log(res_data);
                })
            },
            getKabupaten: function(){
                fetch(ADD_KABUPATEN+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value
                    })
                }).then((res) => res.json()).then((datanya) => {
                    console.log('GET KABUPATEN ===================================');
                    console.log(datanya);
                  this.nama_kabupaten = datanya.data[0];

                })
            },
            getRenstra: function(){
                fetch(ADD_RENSTRA+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      unit_kerja : this.unit_kerja,
                      rpjmd_id : this.rpjmd_id
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.renstraku = res_data.data[0]
                })
            },
            getVisi: function(){
                fetch(ADD_VISI, {
                    method : 'GET',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    }
                }).then((res) => res.json()).then((data_visi) => {
                    console.log(data_visi);
                    this.rpjmd_visi = data_visi[0];
                })
            },
            getRenstraVisi: function(){
                fetch(ADD_RENSTRA_VISI+'readDataLaporan', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      unit_kerja : this.unit_kerja
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.renstra_visi = res_data[0]
                })
            },

            getMisi: function(){
                fetch(ADD_RENSTRA_MISI+'laporanMisiRPJMD', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      unit_kerja : this.unit_kerja,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.list_rpjmd_misi = res_data
                    // this.rpjmd_visi = data_visi[0];
                })
            },
            getRenstraMisi: function(){
                fetch(ADD_RENSTRA_MISI+'laporanMisiRenstra', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      unit_kerja : this.unit_kerja,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    console.log(res_data);
                    this.list_renstra_misi = res_data
                    // this.rpjmd_visi = data_visi[0];
                })
            },
            getRenstraSasaran: function(){
                fetch(ADD_RENSTRA_SASARAN+'laporanSasaranRenstra', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      unit_kerja : this.unit_kerja,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    // console.log(res_data);
                    this.list_renstra_sasaran = res_data
                    // this.rpjmd_visi = data_visi[0];
                })
            },
            getRenstraIndikatorSasaran: function(){
                fetch(ADD_RENSTRA_SASARAN+'laporanIndikatorSasaranRenstra', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      unit_kerja : this.unit_kerja,
                    })
                }).then((res) => res.json()).then((res_data) => {
                    console.log('========================= getRenstraIndikatorSasaran');
                    console.log(res_data);
                    this.list_renstra_indikator_sasaran = res_data
                    // this.rpjmd_visi = data_visi[0];
                })
            },
            

            getData : function(){


                console.log(this.unit_kerja);
                this.getKabupaten();
                this.getRenstra();
                // this.getUnitKerja();
                this.getRPJMD();
                this.getVisi();
                this.getRenstraVisi();
                this.getMisi();
                this.getRenstraMisi();
                this.getRenstraSasaran();
                this.getRenstraIndikatorSasaran();
            },

        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                
                this.renstraku = '';
                this.rpjmd_visi = {};
                this.periode = '';
                this.renstra_visi = '';
                this.tahun_awal = ''; 
                this.tahun_akhir = ''; 
                this.rpjmd_id = ''; 
                this.no_perda = ''; 
                this.tgl_perda = ''; 

                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;

                this.list_rpjmd_misi= [];
                this.list_renstra_misi = [];
                this.list_renstra_sasaran = [];
                this.list_renstra_indikator_sasaran = [];

                this.getData();
                // console.log(obj);
                
            },
        // ================== AUTOCOMPLETE ====================

        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                if (this.rpjmd_id != '') {
                    this.check_data_add = true;
                }
            }, 
            Printing : function(){
                // printMe
                var elem = document.getElementById("printMe");
                var domClone = elem.cloneNode(true);

                var $printSection = document.getElementById("printSection");

                if (!$printSection) {
                    var $printSection = document.createElement("div");
                    $printSection.id = "printSection";
                    document.body.appendChild($printSection);
                }

                $printSection.innerHTML = "";
                $printSection.appendChild(domClone);
                window.print();

            },
        // ================== PAGINASI ====================
        },
    // =============================================================== METHODS =========================================================================

    };
</script>
